var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMicrosoftDynamicsIconSquare = function SvgMicrosoftDynamicsIconSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "microsoft-dynamics-icon-square_svg__a",
    x1: 11.34,
    y1: 34.23,
    x2: 26.34,
    y2: 12.23,
    gradientTransform: "matrix(1 0 0 -1 0 42)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0c50d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#381e96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "microsoft-dynamics-icon-square_svg__b",
    x1: 21.42,
    y1: 22.42,
    x2: 22.92,
    y2: 11.42,
    gradientTransform: "matrix(1 0 0 -1 0 42)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7a4da2",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5da3ff"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 9.21v7.72c0 .34.21.64.53.75l6.37 2.25c.78.28 1.6-.3 1.6-1.13v-3.69c0-.55.53-.93 1.05-.76l2.08.69a2 2 0 0 1 1.37 1.9v7.76c0 1.08-.69 2.03-1.71 2.37l-1.87.62a.701.701 0 0 1-.92-.66V21.5l-2.89 1.24c-.37.16-.61.52-.61.92v7.59c0 .84.84 1.42 1.63 1.12l9.32-3.58a3.196 3.196 0 0 0 2.05-2.99v-9.7a3 3 0 0 0-1.98-2.82l-14.41-5.2c-.78-.28-1.61.3-1.61 1.13Z",
    style: {
      fill: "url(#microsoft-dynamics-icon-square_svg__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5 25.94V16c0 .91-.54 1.73-1.38 2.08l-11.01 4.66c-.37.16-.61.52-.61.92v7.88c0 .7.7 1.19 1.36.93l9.72-3.74a3 3 0 0 0 1.92-2.8Z",
    style: {
      fill: "url(#microsoft-dynamics-icon-square_svg__b)"
    }
  }));
};
export default SvgMicrosoftDynamicsIconSquare;